<template>
	<b-form-group class="labeled-input" :label="label" :label-for="inputId" :id="id || ''" :class="cssClass">

		<b-input-group v-if="type !== 'select'" :prepend="prepend" :append="append" :size="size">

      <template #prepend v-if="$slots.prepend">
        <slot name="prepend"/>
      </template>

      <template #append v-if="$slots.append">
        <slot name="append"/>
      </template>

			<slot>

				<blumar-decimal-input v-if="type === 'decimal'"
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					:value="value" @input="$emit('input', $event)"
					:size="size || 'md'"
					:allowNegative="allowNegative"
					/>

				<blumar-exchange-input v-else-if="type === 'exchange'"
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					:value="value" @input="$emit('input', $event)"
					:size="size || 'md'"
					:allowNegative="allowNegative"
					/>

				<blumar-date-input v-else-if="type === 'date'"
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					:value="value" @input="$emit('input', $event)"
					:size="size || 'md'"
					/>

				<b-form-input v-else-if="mask"
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					:value="value" @input="$emit('input', $event)"
					:size="size || 'md'"
					v-mask="mask"
					/>

				<b-form-input v-else
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					:type="type"
					:size="size || 'md'"
					:value="value" @input="$emit('input', $event)"
					/>

			</slot>

		</b-input-group>

		<slot v-else>
			<b-form-select
				v-bind="$attrs" v-on="$listeners" :id="inputId"
				:value="value" @input="$emit('input', $event)"
				:size="size || 'md'"
				:options="options" :textField="textField || 'name'" :valueField="valueField || 'id'"
				/>
		</slot>

	</b-form-group>
</template>

<script>
import mask from 'awesome-mask';
import moment from 'moment';
import BlumarExchangeInput from './BlumarExchangeInput.vue';
import BlumarDateInput from './BlumarDateInput.vue';
export default {
  components: { BlumarExchangeInput, BlumarDateInput },
	directives: { mask },
	props: ['value', 'type', 'label', 'id', 'cssClass', 'options', 'textField', 'valueField', 'prepend', 'append', 'size', 'allowNegative', 'mask'],
	computed: {
		inputId() {
			if (this.id)
				return this.id + '-input';
			return '';
		}
	},
	methods: {
		formatDate(format) {
			return moment(this.value, 'DD/MM/YYYY').format(format);
		},
		isoDate() {
			return this.formatDate('YYYY-MM-DD');
		},
		formatNumber() {
			return this.value.replace(',', '.');
		}
	}
}
</script>

<style scoped lang="scss">
.labeled-input {
	& >>> legend {
		font-weight: bold;
	}
  & >>> label {
		font-weight: bold;
  }
	.bv-no-focus-ring {
		width: 100%;
	}
	& >>> [role="group"], & >>> .bv-no-focus-ring, select {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LabeledInput.vue